/** @flow */
import { combineReducers } from "redux";
import reports from "./reports";
import report from "./report";

export default combineReducers({
  reports,
  report,
});
